import apiClient from '@/services/axios'

export async function get(query) {
  var params = {
    'venue-details-id': query.venueDetailsId.id,
    'from-date': query.nightStart,
    'to-date': query.nightEnd
  }

  var response = await apiClient.get(process.env.VUE_APP_MARCOM_API_BASE_URL + '/admin/guest-list-items', { params: params });

  if (response) {
    console.log(response)
    return response.data;
  }

  throw new Error('Unable to get guest list items.')
}
